import { createAction } from 'redux-actions';
import { push } from 'react-router-redux';

import { hotelData as staticHotelData } from 'util/hotel';
import { translate } from 'util/i18n';

import { wrapFetch } from './endpoint';

export const changeHotel = createAction('CHANGE_HOTEL', hotel => ({ hotel }));

export const hotelPathRedirect = createAction('HOTEL_PATH_REDIRECT', hotel => async dispatch => {
	await dispatch(push({ pathname: `/${hotel}` }));
	await dispatch(changeHotel(hotel));
});

export const getHotelList = createAction('FETCH_HOTEL_LIST', () => async (_, getState) => {
	const {
		global: { lan },
	} = getState();

	const {
		status,
		message,
		data: { data },
	} = await wrapFetch('api/v1/web/store', {
		method: 'GET',
	});

	if (status !== 200) {
		throw new Error(message);
	}

	const translation = translate(lan);
	const translatedHotelData = staticHotelData(translation);
	const validHotelList = Object.keys(translatedHotelData);

	/* filter out the hotels which are not fully updated yet */
	const hotelList = ['main', ...data.map(hotel => hotel.name)]
		.filter(hotel => validHotelList.includes(hotel));

	return {
		hotelList,
	};
});

export const getAllHotelData = createAction(
	'GET_ALL_HOTEL_DATA',
	() => async (dispatch, getState) => {
		await dispatch(getHotelList());
		const {
			global: { lan },
			hotel: { hotelList },
		} = getState();

		const translation = translate(lan);
		const translatedHotelData = staticHotelData(translation);

		const hotelData = {};

		hotelList.forEach(hotel => {
			hotelData[hotel] = translatedHotelData[hotel];
		});

		return {
			hotelData,
		};
	},
);

export const getHotelMeta = createAction('GET_HOTEL_META', async (lan, hotel, page) => {
	const { status, message, data } = await wrapFetch(
		`api/v1/web/${lan}/${hotel}/meta?page=${page}`,
		{
			method: 'GET',
		},
	);

	if (status !== 200) {
		throw new Error(message);
	}

	return { data };
});

export const getMainPageMeta = createAction('GET_MAIN_PAGE_META', async lan => {
	const { status, message, data } = await wrapFetch(`api/v1/web/${lan}/brandMeta`, {
		method: 'GET',
	});

	if (status !== 200) {
		throw new Error(message);
	}

	return { data };
});



// WEBPACK FOOTER //
// ./src/actions/hotel.js